//  Default locale
import ptBR from './pt-BR'

// Type workaround to ensure that all locale files will have the same set of keys
type Locale = typeof ptBR
type LocalesObject = { [key: string]: Locale }

// Additional locales
import enUS from './en-US'
import deDE from './de-DE'
import es419 from './es-419'

export const defaultLanguage = 'pt-BR'

const locales: LocalesObject = {
  'pt-BR': ptBR,
  'en-US': enUS,
  'de-DE': deDE,
  'es-419': es419
}

export default locales
